
export const sortByOptions = [
  {
    label : "Bestsellers",
    value : "bestsellers"
  },
  {
    label : "Newest first",
    value : "newest"
  },
  {
    label : "Oldest first",
    value : "oldest"
  },
  {
    label: "Price: low to high",
    value: "lowtohigh"
  },
  {
    label: "Price: high to low",
    value: "hightolow"
  },
]